module.exports = __webpack_public_path__ + "img/31.f10baf30.png";